import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import customDataReducer from "@TKCCP/Store/CustomHandlerCreator/CustomDataReducer";

(reducers as any).tKCCPData = customDataReducer;

type CustomReducers = {
    tKCCPData: typeof customDataReducer;
};

// creating custom actions along our custom reducers & OOTB actions from AnyAction
export type CustomActions = Parameters<CustomReducers[keyof CustomReducers]>[1] | AnyAction;
